export type RawData<T> = T[];

export enum TransactionStatusEnum {
  Pending = "PENDING",
  Completed = "COMPLETED",
  Failed = "FAILED",
  Cancelled = "CANCELLED",
  Expired = "EXPIRED",
  Won = "WON",
  Lost = "LOST",
  Reverted = "REVERTED",
  Draw = "DRAW",
  Rejected = "REJECTED",
}

export enum TransactionTypeEnum {
  Deposit = "DEPOSIT",
  Withdrawal = "WITHDRAWAL",
  PrizeWinnings = "PRIZE-WINNINGS",
  Trade = "TRADE",
  Winnings = "WINNINGS",
  Bonus = "BONUS",
}

export interface Trade {
  tradeId: string;
  userId: string;
  transactionStatus: TransactionStatusEnum;
  transactionType: TransactionTypeEnum;
  tradeDirection: "UP" | "DOWN";
  tradeWonId: null;
  gameId: string;
  riskFlag: string | null;
  product: string;
  asset: string;
  currency: string;
  amount: number;
  profit: number;
  payoutRatio: number | null;
  potentialWinnings: number | null;
  createdAt: string;
  updatedAt: string;
  tradeTimestamp: string | null;
  adminAction: string | null;
  adminReason: string | null;
  adminId: string | null;
  tradeTime: number;
  country?: string;
}

export interface AggregatedTradeData {
  userId: string;
  tradingResult: number;
  numberOfTrades: number;
  tradingTurnover: number;
  winningTradesCount: number;
  losingTradesCount: number;
  drawTradesCount: number;
  revertedTradesCount: number;
  winRate: number;
  lossRate: number;
  drawRate: number;
  revertRate: number;
  groupKey: string;
  groupValues: string[];
  trades: Trade[];
}

export interface ReportFilter {
  fromDate?: string;
  toDate?: string;
  userId?: string;
  country?: string;
  riskFlag?: string;
  asset?: string[];
  groupBy?: // General grouping options
  | "client"
    | "time"
    // Trade grouping options
    | "instrument"
    | "timeframe"
    | "country"
    | "accountGroup"
    // Deposit grouping options
    | "psp";
  timeGroup?: "day" | "week" | "month";
  limit?: number;
  sortField?: string;
  sortOrder?: string;
}
export interface Grouping {
  groupBy: ReportFilter["groupBy"];
  groupFilter: string[];
  timeGroup?: ReportFilter["timeGroup"];
}

export interface Deposit {
  depositId: string;
  userId: string;
  transactionStatus: TransactionStatusEnum;
  transactionType: TransactionTypeEnum;
  product: string;
  psp: string | null;
  pspTransactionId: string | null;
  currencyType: string | null;
  amount: number;
  localAmount: number | null;
  localCurrency: string | null;
  exchangeRate: number | null;
  createdAt: string;
  updatedAt: string | null;
  adminAction: string | null;
  adminReason: string | null;
  adminId: string | null;
}

export interface AggregatedDepositData {
  userId: string;
  psp: string;
  numberOfDeposits: number;
  amount: number;
  groupKey: string;
  groupValues: string[];
  deposits: Deposit[];
}

export interface Withdrawal {
  withdrawalId: string;
  userId: string;
  transactionStatus: TransactionStatusEnum;
  transactionType: TransactionTypeEnum;
  product: string;
  psp: string | null;
  pspTransactionId: string | null;
  currencyType: string | null;
  amount: number;
  localAmount: number | null;
  localCurrency: string | null;
  exchangeRate: number | null;
  createdAt: string;
  updatedAt: string | null;
  adminAction: string | null;
  adminReason: string | null;
  adminId: string | null;
}

export interface AggregatedWithdrawalData {
  userId: string;
  psp: string;
  numberOfWithdrawals: number;
  amount: number;
  groupKey: string;
  groupValues: string[];
  withdrawals: Withdrawal[];
}
